import { LANGUAGE_DIRECTIONS } from "@constants/languages";
import i18n from "i18next";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Language, LanguageDirection } from "../types/configs";

export const getLanguageDirection = () => {
  const currentLanguage = i18n?.language as Language;
  return LANGUAGE_DIRECTIONS[currentLanguage] ?? LanguageDirection.LTR;
};

export const useLanguageDirection = (): LanguageDirection => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language as Language;

  return useMemo(() => {
    return LANGUAGE_DIRECTIONS[currentLanguage] ?? LanguageDirection.LTR;
  }, [currentLanguage]);
};

export const useUpdateLanguageDirection = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n?.language as Language;

  // Update lang and dir attributes on HTML element when current language changes
  useEffect(() => {
    document.documentElement.setAttribute("lang", currentLanguage);

    const langDir = LANGUAGE_DIRECTIONS[currentLanguage] ?? LanguageDirection.LTR;

    document.documentElement.setAttribute("dir", langDir);
  }, [currentLanguage]);
};
